import React, { Component } from 'react';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';

export default class GanKao extends Component {
    constructor(props) {
        super(props)
        this.bishun_data = window.AllBooksForPress;
        this.state = {
            srcString: 'http://www.gankao.com/p-lubo/tag/tbsz',
        }
    }

    componentDidMount() {
        //跨域
        if (document.domain != 'gankao.com') {
            document.domain = 'gankao.com'
        }
    }

    render() {
        return (
            <div className="bookListBox">
                <style>{`
                    .tab li a.active{
                        color:#11B5FF;
                        border-bottom: 2px solid #11B5FF;
                        border-radius: 2px;
                    }
                    .tab{
                        border-bottom: 1px solid #E2F4FF;
                        padding:0 0 5px 0;
                        display:flex;
                        justify-content:space-around;
                        align-items:center;
                    }
                    .tab li a{
                        padding:10px 0;
                        color: #666;
                    }
                `}</style>
                <Helmet title="笔顺书法" />
                <ul className="tab">
                    <li>
                        <Link to={`/Word`} activeClassName="active">汉字笔顺</Link>
                    </li>
                    <li>
                        <Link to={`/TongBuShuFa`} activeClassName="active">同步笔顺</Link>
                    </li>
                    <li>
                        <Link to={`/TongBu`} activeClassName="active">同步书法</Link>
                    </li>
                </ul>
                {this.props.children && this.props.children}
                {!this.props.children &&
                    <div>
                        {this.bishun_data.map((item, index) => {
                            return <Link key={"press" + index} to={`/press/${item.presspinyin}`}>
                                <div className="pressItem">
                                    {item.pressname}
                                </div>
                            </Link>
                        })}
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/gankao/GanKao.js